import Vue from 'vue'
import VueRouter from 'vue-router'
import Manager from "@/views/Manager";
import DeviceMonitorLog from "@/views/manager/DeviceMonitorLog"; // 导入DeviceMonitorLog组件
import SystemLog from "@/views/manager/SystemLog"; // 导入SystemLog组件

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/device',  // 重定向到设备信息页面
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      // { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') }, // 组件不存在，已注释
      { path: 'userManagement', name: 'UserManagement', meta: { name: '用户管理' }, component: () => import('../views/manager/UserManagement') },
      { path: 'device', name: 'Device', meta: { name: '设备信息' }, component: () => import('../views/manager/Device') },
      { path: 'commandSystem', name: 'CommandSystem', meta: { name: '指令系统' }, component: () => import('../views/manager/CommandSystem') },
      { path: 'deviceMap', name: 'DeviceMap', meta: { name: '设备地图' }, component: () => import('../views/manager/DeviceMap') },
      { path: 'geofence', name: 'Geofence', meta: { name: '电子围栏' }, component: () => import('../views/manager/Geofence') },
      { path: 'log', name: 'Log', meta: { name: '系统日志' }, component: () => import('../views/manager/SystemLog') },
      // { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/manager/Person') }, // 组件不存在，已注释
      // { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') }, // 组件不存在，已注释
      { path: 'deviceMonitorLog', name: 'DeviceMonitorLog', meta: { name: '设备监控日志' }, component: () => import('../views/manager/DeviceMonitorLog') },
      { path: 'systemLog', name: 'SystemLog', meta: { name: '系统日志' }, component: () => import('../views/manager/SystemLog') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 保护需要认证的路由
router.beforeEach((to, from, next) => {
  // 公开路径，无需认证
  const publicPaths = ['/login', '/register', '/404']

  // 检查是否是公开路径
  if (publicPaths.includes(to.path)) {
    next()
    return
  }

  // 获取用户信息
  let user = null
  try {
    user = JSON.parse(localStorage.getItem("xm-user") || '{}')
  } catch (error) {
    console.error('解析用户信息失败:', error)
    localStorage.removeItem("xm-user")
    next('/login')
    return
  }

  // 检查是否有有效的token
  if (!user.accessToken) {
    console.warn('未登录，跳转到登录页')
    next('/login')
    return
  }

  // 已登录，允许访问
  next()
})

export default router
